import React from "react";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton";
import DeleteButton from "../deleteButton/deleteButton";
import IntInput from "../intInput/intInput";
import Provider from "./Provider";
export default function TiersProvider(props) {
    var _a;
    const { provider } = props;
    if (provider.tiers === undefined) {
        props.onProviderUpdate({
            type: 'per-item-tiers-provider',
            tiers: [],
            priceForAllNext: { type: 'constant', value: 15 },
        });
        return React.createElement(React.Fragment, null);
    }
    function updateTier(index, value) {
        props.onProviderUpdate(Object.assign(Object.assign({}, provider), { tiers: provider.tiers.map((tier, i) => i !== index ? tier : value) }));
    }
    return (React.createElement("div", { className: "" }, (_a = provider.tiers) === null || _a === void 0 ? void 0 :
        _a.map((tier, index) => (React.createElement("div", { className: "tier-provider-tier", key: index },
            React.createElement("div", null,
                React.createElement("div", { className: "match-condition-part" }, index === 0 ? 'Pierwsze ' : 'Kolejne '),
                React.createElement(IntInput, { defaultValue: tier.next, label: "Sztuk", onChange: (newNumber) => updateTier(index, Object.assign(Object.assign({}, tier), { next: newNumber })) })),
            React.createElement("div", null,
                React.createElement("div", null, "W cenie"),
                React.createElement(Provider, { provider: tier.price, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => {
                        return updateTier(index, Object.assign(Object.assign({}, tier), { price: newP }));
                    }, formatNames: props.formatNames }),
                React.createElement("div", null, "Za sztuk\u0119")),
            React.createElement(DeleteButton, { onClick: () => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { tiers: provider.tiers.filter((_, i) => i !== index) })) })))),
        React.createElement("br", null),
        React.createElement(Button, { text: "Dodaj nowy skok cenowy", version: "transparent-stylish-old", value: "add-new-element", onClick: () => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { tiers: [...provider.tiers, {
                        next: 5,
                        price: { type: 'constant', value: 15 },
                    }] })) }),
        React.createElement("div", { className: "match-condition-part" }, "Ka\u017Cde kolejne"),
        React.createElement(Provider, { provider: provider.priceForAllNext, hasHiddenType: props.hasHiddenType, onProviderUpdate: (newP) => props.onProviderUpdate(Object.assign(Object.assign({}, provider), { priceForAllNext: newP })), formatNames: props.formatNames }),
        React.createElement("div", { className: "match-condition-part" }, "Za sztuk\u0119")));
}
